import { cn } from '@wwe-portal/ui/lib/lib';
import { FC } from 'react';

interface TextChangeProps {
  changed: 'added' | 'removed' | 'none';
  children: React.ReactNode;
  diff: number | null;
  enableDiff?: boolean;
}

export const TextChange: FC<TextChangeProps> = ({
  changed,
  children,
  diff,
  enableDiff = true,
}) => {
  const className = cn({
    'text-green600': changed === 'added' && enableDiff,
    'text-[#FF2A2A]': changed === 'removed' && enableDiff,
    'line-through': diff == null && changed === 'removed' && enableDiff,
  });
  return <span className={className}>{children}</span>;
};
